export default __webpack_public_path__ + "c5a0e6e0d9bfbeb28dead743d09b4c2d.png";